import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { cognitoConfig } from './config/cognitoConfig';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-cluster/lib/assets/MarkerCluster.css';
import 'react-leaflet-cluster/lib/assets/MarkerCluster.Default.css';
import App from './App';

// Configure Amplify once at application startup
console.log('🔧 Configuring AWS Amplify with UCF Cognito...');
Amplify.configure(cognitoConfig);
console.log('✅ Amplify configured successfully');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);